import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="mx-auto flex w-full max-w-content flex-col items-center px-4 py-24 text-center md:px-6 md:py-32">
        <span className="font-heading text-7xl font-black text-background-300 md:text-9xl">404</span>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
          这个页面还没有内容
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的地址是 <span className="text-foreground-950">{location.pathname}</span>
          ，它可能已被移动或尚未开放。可以回到首页，或直接去短剧库查找你想看的作品。
        </p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/dramas"
            className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            浏览短剧库
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}